import { render, staticRenderFns } from "./CombineBrands.vue?vue&type=template&id=4a84077f&scoped=true&"
import script from "./CombineBrands.vue?vue&type=script&lang=js&"
export * from "./CombineBrands.vue?vue&type=script&lang=js&"
import style0 from "./CombineBrands.vue?vue&type=style&index=0&id=4a84077f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a84077f",
  null
  
)

export default component.exports